// extracted by mini-css-extract-plugin
module.exports = {"table":"table-typography_table__Bajyc"};